var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVigilTmLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 39,
    viewBox: "0 0 170 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vigil"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9747 15.2101L58.1599 27.1118L62.3015 15.2101H65.4623L59.5986 30.6867H56.6994L50.814 15.2101H53.9747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.193 30.6867V15.2101H83.2011V30.6867H80.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.939 30.7957C104.937 30.7957 103.985 30.5922 103.084 30.1853C102.197 29.7784 101.413 29.219 100.73 28.5069C100.061 27.7803 99.538 26.9374 99.1602 25.9783C98.7824 25.0192 98.5934 23.9802 98.5934 22.8612C98.5934 21.8003 98.7824 20.8049 99.1602 19.8748C99.538 18.9303 100.068 18.1019 100.751 17.3899C101.434 16.6778 102.234 16.1183 103.149 15.7114C104.065 15.3045 105.06 15.1011 106.136 15.1011C107.589 15.1011 108.831 15.4135 109.863 16.0384C110.909 16.6487 111.694 17.4625 112.217 18.4798L109.972 20.1364C109.58 19.3662 109.027 18.7777 108.315 18.3708C107.618 17.9639 106.855 17.7604 106.027 17.7604C105.373 17.7604 104.777 17.8985 104.239 18.1746C103.701 18.4507 103.236 18.8285 102.844 19.3081C102.452 19.7877 102.147 20.3399 101.929 20.9648C101.725 21.5896 101.623 22.2508 101.623 22.9484C101.623 23.6895 101.732 24.3725 101.95 24.9974C102.183 25.6223 102.503 26.1672 102.909 26.6322C103.331 27.0973 103.818 27.4678 104.37 27.7439C104.922 28.0055 105.532 28.1363 106.201 28.1363C106.986 28.1363 107.734 27.9329 108.446 27.526C109.173 27.1191 109.848 26.5233 110.473 25.7385V28.7031C109.18 30.0981 107.669 30.7957 105.939 30.7957ZM110.255 24.932H107.138V22.7304H112.74V30.6867H110.255V24.932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.383 30.6867V15.2101H131.391V30.6867H128.383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.699 30.6867V15.2101H150.707V28.0491H158.598V30.6867H147.699Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8944 10.8347C14.9887 24.1686 12.4064 28.594 12.4064 28.8075C12.4064 29.032 16.6207 36.3347 17.9955 38.4924C18.2505 38.8927 18.8503 38.883 19.0916 38.4748L20.032 36.8837C20.8424 35.5126 24.9906 28.5025 29.2502 21.3058C33.5095 14.1091 37.0304 8.13503 37.0744 8.03023C37.1182 7.92521 34.3288 7.86706 30.8758 7.90062L27.996 7.92876C25.8893 7.94935 23.9501 9.05396 22.8944 10.8347Z",
    fill: "url(#paint0_linear_9566_7203)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5418 18.2006C17.3128 16.1207 15.8679 13.6806 14.1806 10.8347C13.1249 9.05399 11.1856 7.94938 9.07899 7.92879L6.19912 7.90064C2.74617 7.86709 -0.0432573 7.92523 0.000508049 8.03025C0.0445078 8.13505 3.56546 14.1091 7.82477 21.3058C12.0843 28.5025 16.2326 35.5126 17.0429 36.8837L17.9834 38.4748C18.2247 38.8831 18.8245 38.8927 19.0794 38.4924C19.8122 37.3423 21.3517 34.7306 22.6298 32.5081L31.0829 18.2077C29.8296 20.3176 27.4916 21.7366 24.8144 21.7366C22.1342 21.7366 19.7941 20.3145 18.5418 18.2006Z",
    fill: "url(#paint1_linear_9566_7203)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.896 0V0.498773H163.485V4.18685H162.909V0.498773H161.499V0H164.896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.987 0H166.799L168.002 3.53987L169.196 0H170V4.18685H169.461V1.71578C169.461 1.63028 169.463 1.48872 169.467 1.29111C169.471 1.0935 169.473 0.881641 169.473 0.655531L168.278 4.18685H167.717L166.514 0.655531V0.783787C166.514 0.886392 166.516 1.04315 166.52 1.25406C166.526 1.46307 166.528 1.61698 166.528 1.71578V4.18685H165.987V0Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9566_7203",
    x1: 37.193,
    y1: 38.5256,
    x2: -0.430082,
    y2: 38.5562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#066CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222222"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9566_7203",
    x1: -9.04639,
    y1: 23.3301,
    x2: 27.9084,
    y2: 23.6383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#066CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A0FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVigilTmLogoWhite);
export default __webpack_public_path__ + "static/media/vigilTMLogoWhite.fcd333ffae7f8b413b49d4168eedd1be.svg";
export { ForwardRef as ReactComponent };